
<template>

<el-row>

  <el-form :inline="true"  class="demo-form-inline">
    <el-form-item v-if="loginInfo.loginPath=='cxh'">
      <el-input  v-model="form.keyword"   placeholder="单号/用户/渠道"></el-input>
    </el-form-item>
    <el-form-item  v-else >
      <el-input  v-model="form.keyword" placeholder="单号/用户"></el-input>
    </el-form-item>
    <el-form-item>
      <el-select clearable v-model="form.payStatus" placeholder="请选择支付状态" @change="loadList()">
        <el-option :value="1" label="待支付"></el-option>
        <el-option :value="2" label="支付成功"></el-option>
        <el-option :value="5" label="转入退款"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item>
      <el-input v-model="form.money" placeholder="请输入订单金额" type="number" ></el-input>
    </el-form-item>
    <el-form-item>
      <el-select clearable v-model="form.goodType"  placeholder="请选择收费类型" @change="loadList()">

          <el-option :value="4" label="维保查询"></el-option>
          <el-option :value="8" label="碰撞查询"></el-option>
          <el-option :value="9" label="帖子置顶"></el-option>
        <el-option :value="10" label="二手车发布"></el-option>
        <el-option :value="11" label="二手车置顶"></el-option>
        <el-option :value="12" label="个人车拨打"></el-option>

      <!--  <el-option :value="3" label="联系车主"></el-option>
        <el-option :value="5" label="出险查询"></el-option>
        <el-option :value="6" label="违章查询"></el-option>
        <el-option :value="7" label="估价查询"></el-option>-->

      </el-select>
    </el-form-item>

    <el-form-item>
      <el-date-picker v-model="form.time" type="datetimerange" start-placeholder="开始时间"  end-placeholder="结束时间" @change="onTimeChange">
      </el-date-picker>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="loadList()" size="small" >查询</el-button>
    </el-form-item>
    <el-form-item>
      <el-button v-belong-to-channel type="primary" @click="payNoticedialogVisible = true" size="small"> 开通收入微信通知</el-button>
    </el-form-item>
    <el-form-item>
      <el-button type="danger" @click="exportExcel()" size="small"  v-belong-to-admin >导出</el-button>
    </el-form-item>

    </el-form>

    <el-dialog
            title="开通收入微信通知"
            :visible.sync="payNoticedialogVisible"
            width="40%"
             >
        <el-row>
            <p style="color: #F56C6C;">开通后可接收汽车网每笔收款通知，支持多人同时接收通知！</p>

        </el-row>
        <el-row>

            <el-col :span="12">
                <p><strong>第一步关注公众号</strong></p>
                <el-image  style="width: 200px; height: 200px" src="https://csz-public.oss-cn-hangzhou.aliyuncs.com/ClueDistribution/qr/2018-09-28/1538129402999.jpg"></el-image>

            </el-col>

            <el-col :span="12">
                <p><strong>第二步扫码开通通知</strong></p>
                <el-image  style="width: 200px; height: 200px" :src="baseUrl+'/channel/getSubjectTemplateMsgQr.action?key='+form.channelId"></el-image>

               </el-col>
        </el-row>
        <el-row>温馨提示：开通后，暂不支持关闭微信通知，如需关闭请联系您的负责人！</el-row>

        <span slot="footer" class="dialog-footer">
  </span>
    </el-dialog>
    <el-row style="margin-top:20px;">

        <el-table :data="datas" border style="width: 100%"     tooltip-effect="dark">
            <el-table-column label="订单单号">
                <template scope="scope">
                    <span>{{ scope.row.orderNumber }}</span>
                </template>
            </el-table-column>

            <el-table-column label="收费用户">
                <template scope="scope">
                    <p> {{ scope.row.personName }} - {{scope.row.personPhone}}</p>
                </template>
            </el-table-column>

            <el-table-column label="收费类型">
                <template scope="scope">
                    <span>{{ scope.row.goodType | goodsTypeFilter}}</span>
                </template>
            </el-table-column>

            <el-table-column label="来源渠道" v-if="isAdmin">
                <template scope="scope">
                    <span>{{ scope.row.channelName }}</span>
                </template>
            </el-table-column>

            <el-table-column label="订单金额">
                <template scope="scope">
                    <span>{{ scope.row.totalMoney/100 }} 元</span>
                </template>
            </el-table-column>

            <el-table-column label="支付状态">
                <template scope="scope">
                    <p> {{ scope.row.payStatus | payStatusFilter}}</p>
                </template>
            </el-table-column>

            <el-table-column label="成本" prop="note">
              <template scope="scope">
                  <span>{{scope.row.costPrice/100}} 元</span>
              </template>
            </el-table-column>

            <el-table-column label="支付时间 ">
                <template scope="scope">
                    <p class=" text-nowrap">{{ scope.row.payTime | dateTimeFormat}}</p>
                </template>
            </el-table-column>
            <el-table-column label="渠道收入(订单金额-成本)*分成比例 ">
                <template scope="scope">
                    <p class=" text-nowrap">{{ scope.row.channelShareOutBonus/100}}元</p>
                </template>
            </el-table-column>
            <el-table-column label="车小花收入 " v-if="isAdmin" >
                <template scope="scope">
                    <p class=" text-nowrap">{{ scope.row.sxbShareOutBonus/100}} 元</p>
                </template>
            </el-table-column>
            <el-table-column label="创建时间" >
                <template scope="scope" >
                    <p class=" text-nowrap">{{ scope.row.createTime | dateTimeFormat}}</p>
                </template>
            </el-table-column>

        </el-table>
        <el-pagination style="margin-left:0px" class="row basic-margin" @size-change="fn" @current-change="fn" :current-page="currentPage" :page-size="10" layout="total, prev, pager, next, jumper" :total="total">
        </el-pagination>
    </el-row>
</el-row>

</template>

<script>

import BasicPager from '@/mixins/BasicPager'
import Config from '@/framework/configs/Config'
import BasicModel from '@/framework/basic/BasicModel'
import PincheConfig from '../channelManagement/children/pincheConfig'
import usedCarSingleSelect from '@/components/usedCarSingleSelect'
export default {
  name: 'free-order-management',
  components: { PincheConfig, usedCarSingleSelect },
  extends: BasicPager,
  data: function () {
    return {
      baseUrl: Config.baseUrl,
      payNoticedialogVisible: false,
      isAdmin: false,
      datas: [],
      channelId: null,
      form: {
        payStatus: null,
        goodType: null,
        money: null,
        channelId: null,
        usedCarSingleInfoId: null
      },
      currentPage: 1,
      total: 0,
      loading: false
    }
  },
  created: function () {
    let userInfo = JSON.parse(localStorage.userInfo)
    this.isAdmin = userInfo.loginPath != 'channel'
    if (!this.isAdmin) {
      // this.$set(this.form,channelId ,this.loginInfo.id)
      this.form.channelId = this.loginInfo.id
      this.channelId = this.loginInfo.id
    }
    this.loadList(1)
  },
  filters: {

    payStatusFilter: function (value) {
      // 支付状态:1-待支付；2-支付成功;3-支付失败;4-支付关闭;5-转入退款;6-取消支付;7-支付中
      let str = ''
      switch (value) {
        case 1:
          str = '待支付'
          break
        case 2:
          str = '支付成功'
          break
        case 3:
          str = '支付失败'
          break
        case 4:
          str = '支付关闭'
          break
        case 5:
          str = '转入退款'
          break
        case 6:
          str = '取消支付'
          break
        case 7:
          str = '支付中'
          break
        default:
      }
      return str
    },
    goodsTypeFilter: function (value) {
      // 商品名称：1-发布二手车、2-置顶、3-联系车主、4-维保查询、5-出险查询、6-违章查询\r\n、7估价;8-碰撞9-帖子
      let str = ''
      switch (value) {
        case 3:
          str = '联系车主'
          break
        case 4:
          str = '维保查询'
          break
        case 5:
          str = '出险查询'
          break
        case 6:
          str = '违章查询'
          break
        case 7:
          str = '估价'
          break
        case 8:
          str = '碰撞查询'
          break
        case 9:
          str = '帖子置顶'
          break
        case 10:
          str = '二手车发布'
          break
        case 11:
          str = '二手车置顶'
          break
        case 12:
          str = '个人车拨打'
          break
        default:
          str = value
      }
      return str
    }

  },
  methods: {
    setUsedCarSingleInfoId: function (value) {
      this.form.usedCarSingleInfoId = value
      this.loadList()
    },
    onTimeChange: function (newValue) {
      if (newValue && newValue[0] && newValue[1]) {
        this.form.startTime = newValue[0].getTime()
        this.form.endTime = newValue[1].getTime()
      } else {
        this.form.startTime = null
        this.form.endTime = null
      }
      this.loadList()
    },
    fn: function (d) {
      this.loadList(d)
    },
    exportExcel: function () {
      // 验证用户登录状态
      let userInfo = this.getLoginInfo()
      if (!userInfo) {
        this.$message('您没有登录哦！')
        return
      }

      let loginPath = userInfo.loginPath
      if (loginPath === 'channel') {
        this.$message('访问限制！')
        return
      }

      let id = userInfo.employeeId

      let url = Config.baseUrl + 'privateUsedCar/findPrivateUsedCarOrderListByExcel.action?token=' + userInfo.token + '&loginAccountId=' + id + '&loginPath=' + loginPath

      if (this.form.startTime && this.form.endTime) {
        url += '&startTime=' + this.form.startTime + '&endTime=' + this.form.endTime
      }

      if (this.form.goodsType) {
        url += '&goodsType=' + this.form.goodsType
      }

      if (this.form.keyword) {
        url += '&keyword=' + this.form.keyword
      }

      if (this.form.payStatus) {
        url += '&payStatus=' + this.form.payStatus
      }
      if (this.form.usedCarSingleInfoId) {
        url += '&usedCarSingleInfoId=' + this.form.usedCarSingleInfoId
      }

      window.location.href = url
    },
    loadList: function (pageNumber) {
      let _this = this

      let param = {
        start: pageNumber,
        length: 10,
        keyword: this.form.keyword,
        goodsType: this.form.goodType,
        payStatus: this.form.payStatus,
        startTime: this.form.startTime,
        endTime: this.form.endTime,
        usedCarSingleInfoId: this.form.usedCarSingleInfoId
      }

      if (this.form.money) {
        param.money = this.form.money * 100
      }
      if (!this.isAdmin) {
        param.channelId = this.form.channelId
      }
      let listener = {
        success: function (dataInfo) {
          _this.datas = dataInfo.data
          _this.total = dataInfo.recordsTotal
          _this.loading = false
        }
      }
      BasicModel.get(_this, 'privateUsedCar/findPrivateUsedCarOrderList.action', param, listener)
    }
  }
}

</script>
